export const VALIDATIONS_CLASS = '__VALIDATIONS_CLASS__';
export const IS_VALIDATIONS_CLASS = '__IS_VALIDATIONS_CLASS__';
export const ATTRS_MODEL = '__ATTRS_MODEL__';
export const ATTRS_PATH = '__ATTRS_PATH__';
export const ATTRS_RESULT_COLLECTION = '__ATTRS_RESULT_COLLECTION__';